const commentsData = [
  {
    name: "Aarav Mehta",
    text: "Bro this video literally changed the way I think about coding 😍🔥",
    replies: []
  },
  {
    name: "Sneha Patil",
    text: "Such a clean explanation! You earned a new subscriber ❤️",
    replies: [
      {
        name: "Rohan Sharma",
        text: "Same here! Very underrated channel 🙌",
        replies: []
      },
      {
        name: "Meera Joshi",
        text: "The code walkthrough was so smooth 🔥",
        replies: [
          {
            name: "Amey Kulkarni",
            text: "Exactly! No unnecessary talking, straight to the point 😄",
            replies: []
          }
        ]
      }
    ]
  },
  {
    name: "Vikas Gupta",
    text: "Saved me hours bro! You explained what others complicate 😭🙏",
    replies: []
  },
  {
    name: "Priya Nair",
    text: "The example at 4:12 was the highlight for me 💡💛",
    replies: [
      {
        name: "Harsh Raj",
        text: "That part made the concept crystal clear 🤯",
        replies: [
          {
            name: "Sahil Khan",
            text: "I replayed that part 4 times 😂",
            replies: [
              {
                name: "Aditya Rao",
                text: "Same bro, worth every second 💯",
                replies: []
              },
              {
                name: "Neha Suresh",
                text: "This is why I love this channel 😄🔥",
                replies: []
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: "Ananya Kulkarni",
    text: "I wish I found your channel earlier ❤️",
    replies: []
  },
  {
    name: "Dhruv Shetty",
    text: "This is what quality content looks like 💯🔥",
    replies: []
  },
  {
    name: "Harshad Gite",
    text: "The editing + explanation combo is OP 🤌🔥",
    replies: [
      {
        name: "Kunal Pawar",
        text: "True! Very professional content ✨",
        replies: []
      }
    ]
  }
];

export default commentsData;